module.exports = {
    secondsToTimeFormat: (seconds) => {
        if (!seconds) return "00:00:00";
        const h = Math.floor(seconds / 3600).toString().padStart(2, '0');;
        const m = Math.floor((seconds % 3600) / 60).toString().padStart(2, '0');;
        const s = Math.floor(seconds % 60).toString().padStart(2, '0');

        return `${h}:${m}:${s}`;
    }
}